import { __assign, __spreadArray } from "tslib";
import { Box, Grid, rem, resolveSxAsArray, Typography } from '@yunex/yds-react';
import React, { memo, useMemo } from 'react';
import { CMP_LIST_HEADER as CMP } from '../../componentNames';
import SavedViewsFilter from './SavedViewsFilter';
var styles = {
    header: {
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: 2,
    },
    root: {
        paddingTop: 4,
    },
    savedViewsFilter: {
        flex: 1,
        minWidth: rem(100),
    },
    title: {
        flexShrink: 0,
        width: rem(180),
    },
};
var ListHeader = memo(function (_a) {
    var containerSx = _a.containerSx, extraInfo = _a.extraInfo, _b = _a.paddedSize, paddedSize = _b === void 0 ? {} : _b, savedViewsProps = _a.savedViewsProps, subtitle = _a.subtitle, disabled = _a.disabled, title = _a.title, savedViewsComponent = _a.savedViewsComponent, filteredItemsCount = _a.filteredItemsCount;
    var subtitleMemo = useMemo(function () {
        if (typeof subtitle === 'function') {
            return subtitle(filteredItemsCount || 0);
        }
        return subtitle;
    }, [filteredItemsCount, subtitle]);
    var rootSx = useMemo(function () {
        return __spreadArray(__spreadArray([styles.root], resolveSxAsArray(paddedSize), true), resolveSxAsArray(containerSx), true);
    }, [paddedSize, containerSx]);
    return (React.createElement(Grid, { alignItems: "center", container: true, rowSpacing: 2, sx: rootSx },
        React.createElement(Grid, { item: true, xs: true },
            React.createElement(Box, { sx: styles.header },
                React.createElement(Box, { sx: styles.title },
                    title && (React.createElement(Typography, { "data-testid": "".concat(CMP, "-title-label"), variant: "h2" }, title)),
                    subtitle && (React.createElement(Typography, { "data-testid": "".concat(CMP, "-subtitle-label"), variant: "body2" }, subtitleMemo))),
                savedViewsComponent !== undefined ? (savedViewsComponent) : (React.createElement(SavedViewsFilter, __assign({}, savedViewsProps, { disabled: disabled, filteredRowsCount: filteredItemsCount }))))),
        extraInfo && React.createElement(Grid, { item: true }, extraInfo)));
});
ListHeader.displayName = CMP;
export default ListHeader;
//# sourceMappingURL=ListHeader.js.map